import PortraitPricingCard from './portrait-pricing-card'
export default PortraitPricingCard
